import onetime from "@-/com.npmjs.onetime";

const getPendingCompletedSlideKeyCounts = onetime((): Map<string, number> => new Map());

export function addPendingCompletedSlideKey(key: string): void {
  const counts = getPendingCompletedSlideKeyCounts();
  counts.set(key, (counts.get(key) ?? 0) + 1);
}

export function removePendingCompletedSlideKey(key: string): void {
  const counts = getPendingCompletedSlideKeyCounts();
  const count = counts.get(key);
  if (count === undefined) {
    return;
  }
  if (count <= 1) {
    counts.delete(key);
    return;
  }
  counts.set(key, count - 1);
}

/** Withdraw every pending mark for one slide: an undone completion leaves it incomplete. */
export function clearPendingCompletedSlideKey(key: string): void {
  getPendingCompletedSlideKeyCounts().delete(key);
}

export function clearPendingCompletedSlideKeys(): void {
  getPendingCompletedSlideKeyCounts().clear();
}

export function getPendingCompletedSlideKeys(): ReadonlySet<string> {
  return new Set(getPendingCompletedSlideKeyCounts().keys());
}
